module.exports = __webpack_public_path__ + "img/deco-left.98a535d.png";